import {
  CategoryHandler,
  CollectionHandler,
  SearchFiltersHandler,
  SearchResultHandler,
  SequenceTypes,
} from '@atlassian/mpac-services-client';

import type {
  IOrchestrationConfig,
  IOrchestrationConfigRecord,
} from '@atlassian/mpac-services-client';

const getConfig = <T extends IOrchestrationConfigRecord>(config: IOrchestrationConfig<T>) => config;

/**
 * Orchestration configuration for DLA
 *
 * `config` accepts both a config and a function returning config. This can be used for returning
 *  configuration based on some feature flag or some custom logic.
 */
const config = getConfig({
  GetMarketplaceSearch: {
    config: () => ({
      sequence: SequenceTypes.CUSTOM_ONLY,
      handler: new SearchResultHandler(),
    }),
  },
  GetMarketplaceFilters: {
    config: () => ({
      sequence: SequenceTypes.CUSTOM_ONLY,
      handler: new SearchFiltersHandler(),
    }),
  },

  GetCollection: {
    config: () => ({
      sequence: SequenceTypes.PRIMARY_FIRST,
      handler: new CollectionHandler(),
    }),
  },

  GetMarketplaceCategory: {
    config: () => ({
      sequence: SequenceTypes.PRIMARY_FIRST,
      handler: new CategoryHandler(),
    }),
  },
});

export { config };
